import * as _ from 'lodash';
import {Injectable} from "@angular/core";

@Injectable()
export class StatusProvider {
    statuses = [
        {code: 1, label: 'Em Aberto'},
        {code: 2, label: 'Liberado Nação Digital'},
        {code: 3, label: 'Liberado Cliente'},
        {code: 4, label: 'Pgto. Pendente'},
        {code: 5, label: 'Pago'},
        {code: 6, label: 'Cancelado'},
        {code: 7, label: 'Perda contábil'},
        {code: 8, label: 'Perda competência'}
    ]

    find(statusCode) {
        const status = this.statuses.filter(status => status.code == statusCode);

        if (_.isEmpty(status))
            throw 'Divisão inválida';

        return status;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/providers/enums/billing-letter/status-provider.ts